import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { Profile } from '@atlaskit/atlassian-navigation/profile';
import LogInIcon from '@atlaskit/icon/core/log-in';

import { NAVIGATION_CHANNEL } from '../../analytics';
import { type AccountMenuLoggedOutStateProps, logInTooltip } from './index';

/**
 * @deprecated Nav3 (`@atlaskit/atlassian-navigation`) support is being removed.
 * This will be removed from the default `@atlassian/account-menu` entrypoint and the `/nav3` entrypoints in the next major version.
 * Use `AccountMenuLoggedOutState` from `@atlassian/account-menu/nav4` instead.
 */
export const AccountMenuLoggedOutStateNav3: React.ComponentType<AccountMenuLoggedOutStateProps> = ({
	testId,
	logInLink,
}) => (
	<Profile
		testId={testId}
		href={logInLink}
		onClick={(event, analytics) => {
			analytics.update({ actionSubjectId: 'logInLink' }).fire(NAVIGATION_CHANNEL);
		}}
		tooltip={logInTooltip}
		icon={<LogInIcon color="currentColor" label="" />}
	/>
);
